const ITEMS = [
  "3M MATCH PRO",
  "STAGES DE FOOTBALL",
  "MATCHS AMICAUX PRO",
  "HAUT NIVEAU",
  "PERFECTIONNEMENT",
  "EXPÉRIENCE & EXIGENCE",
];

const Marquee = ({ className = "" }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden border-y border-gold/20 bg-[#0a0a0a] py-5 ${className}`}
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span
                  className={`font-display text-2xl md:text-3xl tracking-widest uppercase ${
                    i % 2 === 0 ? "text-gold" : "text-stroke-white"
                  }`}
                >
                  {item}
                </span>
                <span className="w-2 h-2 rotate-45 bg-gold/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
